import { InjectionToken } from '@angular/core'
import { Converter, Country } from '@spartacus/core'

export const MB_COUNTRIES_NO_ACCOUNT_NORMALIZER = new InjectionToken<Converter<any, Country[]>>('MbCountriesNoAccountNormalizer')
